import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ExternalNaptarSzolgaltatasPage } from './external-naptar-szolgaltatas.page';

const routes: Routes = [
  {
    path: '',
    component: ExternalNaptarSzolgaltatasPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ExternalNaptarSzolgaltatasPage]
})
export class ExternalNaptarSzolgaltatasPageModule {}
